import { Component, Input } from '@angular/core';
import { BoulderListEntry } from '../../model/boulder-list-entry';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PipesModule } from 'src/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { UsernameComponent } from '../username/username.component';

@Component({
  standalone: true,
  selector: 'app-boulder-list-entry',
  imports: [IonicModule, FormsModule, CommonModule, PipesModule, TranslateModule, UsernameComponent],
  templateUrl: './boulder-list-entry.component.html',
  styleUrls: ['./boulder-list-entry.component.scss'],
})
export class BoulderListEntryComponent {

  @Input('boulder-list-entry')
  boulderListEntry: BoulderListEntry;

  constructor() {
  }

}
